import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AccountService } from '@banyan/features/account/services/account.service';
import { environment } from '@env/environment';

export function localeInterceptor(req: HttpRequest<any>, next: HttpHandlerFn) {
  return _localeInterceptor(inject(AccountService))(req, next);
}

export function _localeInterceptor(accountService: AccountService) {
  return (req: HttpRequest<any>, next: HttpHandlerFn) => {
    if (req.method === 'GET' && req.url.includes(environment.middlewareUrl)) {
      const newReq = req.clone({
        setParams: {
          locale: accountService.user().preferredLanguage,
        },
      });
      return next(newReq);
    }
    return next(req);
  };
}
